import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { Autocomplete as ElAutocomplete } from 'element-ui'
import {
  loadLicenseSuggestIndex,
  searchLicenseSuggestions
} from '@/utils/format-edit/licenseSuggest'

type ElAutocompleteLike = {
  $refs: { input?: { resizeTextarea?: () => void } }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LicenseNameInput',
  props: {
    value: { default: '' },
    placeholder: { default: '' },
    autosize: { default: () => ({ minRows: 1, maxRows: 4 }) }
  },
  emits: ["input"],
  setup(__props: any, { expose, emit }: { emit: ({ (e: 'input', value: string): void }), expose: any, slots: any, attrs: any }) {





const autocomplete = ref<ElAutocompleteLike | null>(null)

function fetchSuggestions(
  query: string,
  respond: (items: { value: string }[]) => void
) {
  loadLicenseSuggestIndex()
    .then((index) =>
      respond(
        searchLicenseSuggestions(index, query || '').map((value) => ({
          value
        }))
      )
    )
    .catch(() => respond([]))
}

// 親（HistoryItem）がカード切替時に textarea の高さを合わせ直すため
expose({
  resizeTextarea: () => autocomplete.value?.$refs.input?.resizeTextarea?.()
})

return { __sfc: true,emit, autocomplete, fetchSuggestions, ElAutocomplete }
}

})